import { render, staticRenderFns } from "./controlsPosition-editor.vue?vue&type=template&id=b4f9d5b4&scoped=true&"
import script from "./controlsPosition-editor.vue?vue&type=script&lang=js&"
export * from "./controlsPosition-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f9d5b4",
  null
  
)

export default component.exports